import React from 'react'

export default function DailyDevCard() {
  return (
    <div className='w-full flex items-center justify-center pt-5 z-50'>
        <a href="https://app.daily.dev/zamanshahed" target="blank" rel="noopener noreferrer"><img src="https://api.daily.dev/devcards/v2/peVtM6BBFfWB36xkIXLIj.png?type=wide&r=pb6" width="652" alt="MD Shahed's Dev Card"/></a>
    </div>
  )
}
